import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './context';
import { AuthLoading } from './AuthLoading';

/**
 * Keeps authenticated users off the unauthenticated screens (sign-in / sign-up):
 * when `status === 'authenticated'` it redirects to `/`; otherwise it renders the
 * children. While the session probe is in flight (`probing`) it waits on a neutral
 * loading state so an already-authenticated user landing on /sign-in never sees a
 * flash of the sign-in form before being redirected home.
 */
export function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  if (status === 'probing') {
    return <AuthLoading />;
  }
  if (status === 'authenticated') {
    return <Navigate to="/" replace />;
  }
  return <>{children}</>;
}
